import { FilterDescription, FilterType } from 'src/components/filters/types';
import { FilterTagsOptions } from 'src/components/filters/FilterTags';
import { FilterMultiselectOptions } from 'src/components/filters/FilterMultiselect';
import { FilterFacepartOptions } from 'src/components/filters/FilterFacepart';

export const FilterOptionsDiscriminator = ({
  filter,
}: {
  filter: FilterDescription;
}) => {
  switch (filter.type) {
    case FilterType.Tags:
      return <FilterTagsOptions filter={filter} />;
    case FilterType.Multiselect:
    case FilterType.Language:
      return <FilterMultiselectOptions filter={filter} />;
    case FilterType.Facepart:
      return <FilterFacepartOptions filter={filter} />;
    default:
      return <></>;
  }
};
